import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueAxios from 'vue-axios'
import axios from 'axios'

// import { Tab, Tabs } from 'vant';
// import 'vant/lib/index.css';
// Vue.use(Tab);
// Vue.use(Tabs);
import '@vant/touch-emulator';
import Vant from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);

// import { Dialog } from 'vant';
// Vue.use(Dialog);
import { Collapse, CollapseItem } from 'vant';
Vue.use(Collapse);
Vue.use(CollapseItem);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import locale from 'element-ui/lib/locale/lang/zh-TW'

import { Locale } from 'vant';
import zhTW from 'vant/es/locale/lang/zh-TW';
Locale.use('zh-TW', zhTW);

Vue.use(ElementUI, { locale })


Vue.use(VueAxios, axios)



Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')